// StickysViewMain.js - Updated to use unified StickyNote component
  import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
  import ZIndexManagerMain from '../services/ZIndexManagerMain';
  import { useNotes } from './contexts/NotesContext';
  import styles from './StickysViewMain.module.css';
  import StickyNote from './StickyNote';  // Import unified StickyNote component
  import StickiesListPanel from './MainPanel/StickiesListPanelMain';
  import { usePanelContext } from './contexts/PanelContext';
  import DraggableFreezeButton from './DraggableFreezeButton'; // Add this import
  import { useWorkspaces } from "./contexts/WorkspacesContext"; // Add this import
  import DraggableAIButton from './DraggableAIButton';
  import AICompositionModal from './AICompositionModal';
  import NotePreviewSticky from './NotePreviewSticky';  // Add this line
  import { fetchTagDomains } from '../api/notesApi'; // Add this import
  import { getKeyPointsFromAI } from '../api/aiKeyPointsApi';
  import { rewriteTextWithAI } from '../api/aiRewrite';  // ADD THIS
  import { uploadImageNote } from '../api/notesApi'; 

  const zManagerInstance = new ZIndexManagerMain();

  const StickysViewMain = ({ 
    selectedDocumentPublicId,
    onFunctionsReady,      // NEW: callback to send functions up
    arrangementMode,        // NEW: receive from parent
    onRequestDelete 
  }) => {
    
    // In StickysViewMain.js
   const { notes, updateNote, removeNote, addNote, saveNoteLayout, reorderNotes, fetchNotes, effectiveNotePublicId } = useNotes();

  // Then change the useEffect to:
  // useEffect(() => {
  //   if (effectiveNotePublicId && notes && notes.length > 0) {
  //     // This will only run when the actual note workspace changes
  //     // Not when switching between parent/subnote
      
  //     // ... existing logic
  //   }
  // }, [effectiveNotePublicId, updateNote]); // Changed dependency


    const [stickyType, setStickyType] = useState('regular');
    const zManagerRef = useRef(zManagerInstance);
    const { getSelectedDocument } = useWorkspaces(); // ✅ Correct function
    const selectedNote = getSelectedDocument();
    const { isRightPanelVisible, isLeftPanelVisible } = usePanelContext();
    const [isAICompositionModalOpen, setIsAICompositionModalOpen] = useState(false);
    const [showNotePreview, setShowNotePreview] = useState(true);  // Add this line
    const [tagDomains, setTagDomains] = useState({});
    const { 
      updateWorkspacePreviewPosition,
      getSelectedWorkspace,
      selectedWorkspacePublicId
    } = useWorkspaces();
    const [showDropMenu, setShowDropMenu] = useState(false);
    const [dropPosition, setDropPosition] = useState({ x: 0, y: 0 });
    const [droppedContent, setDroppedContent] = useState('');
    const [isProcessingDrop, setIsProcessingDrop] = useState(false);
    const [processingIndicators, setProcessingIndicators] = useState([]);
    const currentPreviewPositionRef = useRef(null);

      // ADD THESE CONSTANTS HERE:
    const QUICK_EXTRACTION_TYPES = [
      { key: "keyPoints", title: "Key Points" },
      { key: "detailedInsights", title: "Insights" },
      { key: "quotes", title: "Quotes" }
    ];

    const REWRITE_MODES = [
    { key: "strategic", title: "Strategic" },
    { key: "plain", title: "Plain Language" },
    { key: "conversational", title: "Conversational" },
    { key: "executive", title: "Executive Summary" },
    { key: "bullets", title: "Bullet Points" },
    { key: "empathetic", title: "Empathetic" },
    { key: "analogy", title: "With Analogy" },
    { key: "questions", title: "As Questions" },
    { key: "counterpoint", title: "Counterpoint" }
  ];
    


  const handlePreviewPositionUpdate = useCallback((position) => {
        currentPreviewPositionRef.current = position;
      }, []);


    // 2. Add the arrangement functions (adapted for main_x, main_y coordinates)

  // In StickysViewMain.js, modify the arrangeStickiesDefault function:

  const arrangeStickiesDefault = () => {
    if (!notes || notes.length === 0) return;
    
    console.log("Setting default workspace arrangement...");
    
    // $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ Force NotePreview to be visible and reset to home position BAD  DELETE
    //setShowNotePreview(false); // Hide first
    
    // Reset NotePreview to home position
  // Reset NotePreview to home position (workspace-level)
    if (selectedWorkspacePublicId && updateWorkspacePreviewPosition) {
      console.log("Resetting NotePreview position to home");
      updateWorkspacePreviewPosition(selectedWorkspacePublicId, {
        preview_x: 1,
        preview_y: 5,
        preview_width: 900,
        preview_height: 1000
      });
      console.log('📤 SENT workspace preview update with preview_height: 1000');
    }
    
    //####################################### Force re-render with new position after a brief delay BAD DELETE
    // setTimeout(() => {
    //   setShowNotePreview(true);
    // }, 100);
    
    // ... rest of your existing function code for arranging notes
    const horizontalGap = 30;
    const verticalGap = 30;
    const standardWidth = 600;
    const standardHeight = 250;
    const columnSpacing = standardWidth + horizontalGap;
    
    const startX = window.innerWidth - (2 * standardWidth + horizontalGap + 400);
    const startY = 6;

    const sortedNotes = notes
      .sort((a, b) => (a.list_order || 0) - (b.list_order || 0));
    
    const updates = sortedNotes.map((note, index) => {
      if (index < 6) {
        const columnIndex = index % 2;
        const rowIndex = Math.floor(index / 2);
        
        const main_x = startX + (columnIndex * columnSpacing);
        const main_y = startY + (rowIndex * (standardHeight + verticalGap));
        
        let main_width = standardWidth;
        let main_height = standardHeight;
        
        
        updateNote(note.id, {
          main_x: main_x,
          main_y: main_y,
          main_width: main_width,
          main_height: main_height,
          is_minimized: false,
          display_mode: 'both'
        });
        
        setDisplayModes(prev => ({
          ...prev,
          [note.id]: 'both'
        }));
        
        return {
          id: note.id,
          x: note.x,
          y: note.y,
          width: note.width,
          height: note.height,
          main_x: main_x,
          main_y: main_y,
          main_width: main_width,
          main_height: main_height,
          display_mode: 'both',
          z_index: note.zIndex
        };
      } else {
        // Put remaining notes in list mode with cleared coordinates
        updateNote(note.id, {
          display_mode: 'list',
          main_x: null,
          main_y: null,
          main_width: null,
          main_height: null
        });
        
        setDisplayModes(prev => ({
          ...prev,
          [note.id]: 'list'
        }));
        
        return {
          id: note.id,
          x: note.x,
          y: note.y,
          width: note.width,
          height: note.height,
          main_x: null,
          main_y: null,
          main_width: null,
          main_height: null,
          display_mode: 'list',
          z_index: note.zIndex
        };
      }
    });
    console.log('📤 Sending layout updates:', updates);
    saveNoteLayout(updates);
  };

  const arrangeStickiesExpandedNote = () => {
    if (!notes || notes.length === 0) return;

      if (selectedNote?.public_id && selectedWorkspacePublicId && updateWorkspacePreviewPosition) {
          updateWorkspacePreviewPosition(selectedWorkspacePublicId, {
            preview_x: 1,
            preview_y: 5,
            preview_width: 1700,
            preview_height: 1029
          });
        }
    
  // console.log("Setting expanded note arrangement - minimizing all notes...");
    
    //########################################## Force NotePreview to be visible and expand to full writing mode BAD!
    //setShowNotePreview(false); // Hide first to force re-render
    
    // Expand NotePreview to nearly full screen for focused writing
    // Expand NotePreview to nearly full screen for focused writing (workspace-level)
    if (selectedWorkspacePublicId && updateWorkspacePreviewPosition) {
      console.log("Expanding NotePreview to full writing mode");
      
      updateWorkspacePreviewPosition(selectedWorkspacePublicId, {
        preview_x: 1,
        preview_y: 5,
        preview_width: 1700,
        preview_height: 1029
      });
    } 
    
    //################################################## Force re-render with new expanded position BAD REOMVE!
    // setTimeout(() => {
    //   setShowNotePreview(true);
    // }, 100);
    
    // Minimize ALL notes and position them at bottom as a toolbar
    const barHeight = 45; // Height of minimized note (just the title bar)
    const barWidth = 200; // Width of each minimized note
    const startX = 10; // Start near left edge
    const bottomY = window.innerHeight - 100; // Position near bottom of screen
    const horizontalSpacing = barWidth + 10; // 10px gap between minimized notes
    
    const visibleNotes = notes
    
      .sort((a, b) => (a.list_order || 0) - (b.list_order || 0));
    
    const updates = visibleNotes.map((note, index) => {
      const main_x = startX + (index * horizontalSpacing);
      const main_y = bottomY;
      
      // Minimize all notes
      updateNote(note.id, {
        main_x: main_x,
        main_y: main_y,
        main_width: barWidth,
        main_height: barHeight,
        is_minimized: true, // Key: minimize all notes
        display_mode: 'both'
      });
      
      // Update local display modes
      setDisplayModes(prev => ({
        ...prev,
        [note.id]: 'both'
      }));
      
      return {
        id: note.id,
        x: note.x,
        y: note.y,
        width: note.width,
        height: note.height,
        main_x: main_x,
        main_y: main_y,
        main_width: barWidth,
        main_height: barHeight,
        display_mode: 'both',
        z_index: note.zIndex
      };
    });
    
    saveNoteLayout(updates);
  };
    


  const arrangeStickiesInGrid = () => {
    if (!notes || notes.length === 0) return;
    
    //console.log("Starting grid arrangement in main panel...");
    

    
    // Position NotePreview as minimized bar at top
    if (selectedNote?.public_id && updateWorkspacePreviewPosition) {
    //  console.log("Setting NotePreview as minimized bar at top");
      
      updateWorkspacePreviewPosition(selectedWorkspacePublicId, {
        preview_x: 1,
        preview_y: 5,
        preview_width: 1700,
        preview_height: 45  // Minimized height (just the drag bar)
      });
    }
    
    // Configuration for the grid (existing code unchanged)
    const itemsPerRow = 4;
    const horizontalGap = 30;
    const verticalGap = 30;
    const standardWidth = 520;
    const standardHeight = 450; // Doubled from 180
    const startX = 1;
    const startY = 70; // Start below the minimized note preview bar
    
    // Filter to only visible notes (not in list mode)
    // Filter to only visible notes (not in list mode) and limit to 8
    const visibleNotes = notes
      
        .sort((a, b) => (a.list_order || 0) - (b.list_order || 0))
        .slice(0, 8)
    
    // Create updates for each note (existing logic unchanged)
    const updates = visibleNotes.map((note, index) => {
      const row = Math.floor(index / itemsPerRow);
      const col = index % itemsPerRow;
      
      const main_x = col * (standardWidth + horizontalGap) + startX;
      const main_y = row * (standardHeight + verticalGap) + startY;
      
      // Adjust dimensions based on note type
      let main_width = standardWidth;
      let main_height = standardHeight;
      
      // Update note positions directly
      updateNote(note.id, {
        main_x: main_x,
        main_y: main_y,
        main_width: main_width,
        main_height: main_height,
        is_minimized: false // Keep notes expanded in grid
      });
      
      return {
        id: note.id,
        x: note.x,
        y: note.y,
        width: note.width,
        height: note.height,
        main_x: main_x,
        main_y: main_y,
        main_width: main_width,
        main_height: main_height,
        display_mode: displayModes[note.id] || 'both',
        z_index: note.zIndex
      };
    });
    
    saveNoteLayout(updates);
  };

const arrangeStickiesDocumentRight = () => {
  if (!notes || notes.length === 0) return;
  
  console.log("Setting document-right arrangement...");
  
  // Position document on RIGHT (starting at ~40% of workspace - MORE LEFT)
  if (selectedWorkspacePublicId && updateWorkspacePreviewPosition) {
    const screenWidth = window.innerWidth;
    const documentStartX = Math.floor(screenWidth * 0.25); // ✅ Changed from 0.48 to 0.40
    
    console.log("Positioning document on right side");
    updateWorkspacePreviewPosition(selectedWorkspacePublicId, {
      preview_x: documentStartX,
      preview_y: 2,
      preview_width: Math.floor(screenWidth * 0.60), // ✅ Changed from 0.52 to 0.60
      preview_height: 1050
    });
  }
  
  // Position notes on LEFT in MINIMIZED state
  const minimizedHeight = 45;
  const verticalGap = 10;
  const startX = 10;
  const startY = 10;
  
  // ✅ USE SAME DIMENSIONS AS GRID for expanded state
  const expandedWidth = 600;   // Same as grid
  const expandedHeight = 650;  // Same as grid
  
  const sortedNotes = notes
    .sort((a, b) => (a.list_order || 0) - (b.list_order || 0));
  
  const updates = sortedNotes.map((note, index) => {
    const main_x = startX;
    const main_y = startY + (index * (minimizedHeight + verticalGap));
    
    updateNote(note.id, {
      main_x: main_x,
      main_y: main_y,
      main_width: expandedWidth,    // ✅ Store expanded size
      main_height: expandedHeight,  // ✅ Store expanded size
      is_minimized: true,            // But start minimized
      display_mode: 'both'
    });
    
    setDisplayModes(prev => ({
      ...prev,
      [note.id]: 'both'
    }));
    
    return {
      id: note.id,
      x: note.x,
      y: note.y,
      width: note.width,
      height: note.height,
      main_x: main_x,
      main_y: main_y,
      main_width: expandedWidth,    // ✅ Store expanded size
      main_height: expandedHeight,  // ✅ Store expanded size
      display_mode: 'both',
      is_minimized: true,
      z_index: note.zIndex
    };
  });
  
  console.log('📤 Sending document-right layout updates:', updates);
  saveNoteLayout(updates);
};


  const arrangeStickiesCascade = () => {
    if (!notes || notes.length === 0) return;
    
    const startX = 1;
    const startY = 70;
    const xOffset = 40;
    const yOffset = 40;
    const standardWidth = 450;
    const standardHeight = 180;
    const maxCascadePerColumn = 6; // Limit to 6 per cascade column
    const columnSpacing = 500; // Space between cascade columns
    
    const visibleNotes = notes
      
      .sort((a, b) => (a.list_order || 0) - (b.list_order || 0));
    
    const updates = visibleNotes.map((note, index) => {
      const columnIndex = Math.floor(index / maxCascadePerColumn);
      const positionInColumn = index % maxCascadePerColumn;
      
      const main_x = startX + (columnIndex * columnSpacing) + (positionInColumn * xOffset);
      const main_y = startY + (positionInColumn * yOffset);
      
      let main_width = standardWidth;
      let main_height = standardHeight;
      
      
      updateNote(note.id, {
        main_x: main_x,
        main_y: main_y,
        main_width: main_width,
        main_height: main_height,
        is_minimized: false // Add this line
      });
      
      return {
        id: note.id,
        x: note.x,
        y: note.y,
        width: note.width,
        height: note.height,
        main_x: main_x,
        main_y: main_y,
        main_width: main_width,
        main_height: main_height,
        display_mode: displayModes[note.id] || 'both',
        z_index: note.zIndex
      };
    });
    
    saveNoteLayout(updates);
  };



  // 3. Add the cycle function
const cycleArrangements = useCallback(() => {
  if (!notes || notes.length === 0) return;
  
  let nextMode;
  switch (arrangementMode) {
    case 'default':
      nextMode = 'expandedNote';
      arrangeStickiesExpandedNote();
      break;
    case 'expandedNote':
      nextMode = 'documentRight';  // ✅ Go to documentRight next
      arrangeStickiesDocumentRight();
      break;
    case 'documentRight':  // ✅ Now properly in the sequence
      nextMode = 'grid';
      arrangeStickiesInGrid();
      break;
    case 'grid':
      nextMode = 'cascade';
      arrangeStickiesCascade();
      break;
    case 'cascade':
    default:
      nextMode = 'default';
      arrangeStickiesDefault();
      break;
  }
  
  return nextMode;
}, [arrangementMode, notes]);
    

  useEffect(() => {
    const loadTagDomains = async () => {
      try {
        const domains = await fetchTagDomains();
        setTagDomains(domains);
      } catch (error) {
        console.error('Error loading tag domains:', error);
        // Fallback data
        setTagDomains({
          "General": ["note","summary","draft","todo","follow_up","idea"],
          "Reflection": ["input","observation","reaction","assertion","critique","synthesis"],
          "Story": ["character","scene","setting","premise","conflict","goal","resolution","theme","twist","dialogue","outline"]
        });
      }
    };
    loadTagDomains();
  }, []);


    // State for subnote detection
    const [isSubnote, setIsSubnote] = useState(false);

    // Check if current note is a subnote when selectedDocumentPublicId changes
    useEffect(() => {
    setIsSubnote(selectedNote && selectedNote.parent_id !== null);
  }, [selectedNote]);

    // Add this useEffect in StickysViewMain.js
  useEffect(() => {
    // Clear selections when note changes
    setSelectedStickies({});
    localStorage.removeItem(`selected-notes-${selectedDocumentPublicId}`);
    setDisplayModes({});
  }, [selectedDocumentPublicId]);

  // Update displayModes when notes data loads
  useEffect(() => {
    if (notes && notes.length > 0) {
      setDisplayModes(prev => {
        const newModes = notes.reduce((modes, note) => ({
          ...modes,
          [note.id]: note.display_mode || 'both'
        }), {});
        // console.log("🔄 UPDATING displayModes with loaded notes:", newModes);
        return newModes;
      });
    }
  }, [notes]);
    
  const [displayModes, setDisplayModes] = useState(() => {
    // console.log("🔍 INITIALIZING displayModes - Raw notes data:", notes?.map(s => ({
    //   id: s.id,
    //   display_mode: s.display_mode,
    //   main_x: s.main_x,
    //   main_y: s.main_y
    // })));
    
    const modes = notes?.reduce((modes, note) => {
      //console.log(`Sticky ${note.id}: display_mode="${note.display_mode}" -> setting to "${note.display_mode || 'both'}"`);
      return {
        ...modes,
        [note.id]: note.display_mode || 'both'
      };
    }, {}) || {};
    
    //console.log("🔍 Final displayModes state:", modes);
    return modes;
  });

    const [selectedNotes, setSelectedStickies] = useState(() => {
    const savedSelectStates = localStorage.getItem(`selected-notes-${selectedDocumentPublicId}`);
    return savedSelectStates ? JSON.parse(savedSelectStates) : {};
  });

    // Create a function to register a note with the ZIndexManager
    const registerNoteWithZManager = useCallback((noteId) => {
      //console.log(`Registering new note ${noteId} with ZIndexManager (MAIN)`);
      const newZIndex = zManagerRef.current.addSticky(noteId); 
      //console.log(`Assigned z-index ${newZIndex} to note ${noteId} (MAIN)`);
      return newZIndex;
    }, []);

    const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const droppedText = e.dataTransfer.getData('text/plain') || 
                      e.dataTransfer.getData('text/html') || 
                      '';
    
    if (!droppedText.trim()) return;

    const containerRect = e.currentTarget.getBoundingClientRect();
    const relativeX = Math.max(0, e.clientX - containerRect.left);
    const relativeY = Math.max(0, e.clientY - containerRect.top);
    
    setDropPosition({ x: relativeX, y: relativeY });
    setDroppedContent(droppedText);
    setShowDropMenu(true);
  };

  const renderProcessingIndicators = () => {
    return processingIndicators.map(indicator => (
      <div 
        key={indicator.id}
        className="processing-indicator"
        style={{
          position: 'absolute',
          left: indicator.x,
          top: indicator.y,
          width: '40px',
          height: '40px',
          zIndex: 9999,
          pointerEvents: 'none'
        }}
      >
        <svg viewBox="0 0 100 100" width="100%" height="100%">
          <path
            className="snowflake-path"
            d="M50 15L50 85M15 50L85 50M26 26L74 74M26 74L74 26"
            stroke="#4f46e5"
            strokeWidth="6"
            strokeLinecap="round"
          />
        </svg>
      </div>
    ));
  };

  const handleDropMenuAction = async (action) => {
    setShowDropMenu(false);
    
    const indicatorId = Date.now().toString();
    
    if (action.startsWith('ai_')) {
      // Add processing indicator at drop position
      setProcessingIndicators(prev => [...prev, {
        id: indicatorId,
        x: dropPosition.x,
        y: dropPosition.y
      }]);
      
      const extractionType = action.replace('ai_', '');
      setIsProcessingDrop(true);
      
      try {
        const result = await getKeyPointsFromAI(
          droppedContent, 
          5,
          [extractionType]
        );
        
        const extractedItems = result[extractionType];
        if (extractedItems && extractedItems.length > 0) {
          const typeTitle = QUICK_EXTRACTION_TYPES.find(t => t.key === extractionType)?.title || extractionType;
          let formattedContent = `${typeTitle.toUpperCase()}:\n\n`;
          
          extractedItems.forEach((item, index) => {
            formattedContent += `${index + 1}. ${item}\n\n`;
          });
          
          const topZIndex = zManagerRef.current._getTopZIndex() + 10;
          const newStickyId = await addNote(topZIndex, 'regular');
          
          if (newStickyId) {
            await updateNote(newStickyId, {
              content: formattedContent.trim(),
              zIndex: topZIndex,
              type: 'regular',
              main_x: dropPosition.x,
              main_y: dropPosition.y,
              main_width: 450,
              main_height: 350
            });
            
            handleNoteFocus(newStickyId);
            setDisplayModes(prev => ({...prev, [newStickyId]: 'both'}));
          }
        } else {
          alert('No information could be extracted from the content');
        }
      } catch (err) {
        console.error('Error processing drop with AI:', err);
        alert('Failed to process the text with AI');
      } finally {
        setProcessingIndicators(prev => 
          prev.filter(indicator => indicator.id !== indicatorId)
        );
        setIsProcessingDrop(false);
      }
    } else if (action.startsWith('rewrite_')) {  // ADD THIS BLOCK
      // Add processing indicator
      setProcessingIndicators(prev => [...prev, {
        id: indicatorId,
        x: dropPosition.x,
        y: dropPosition.y
      }]);
      
      const rewriteMode = action.replace('rewrite_', '');
      setIsProcessingDrop(true);
      
      try {
        const rewrittenText = await rewriteTextWithAI(droppedContent, rewriteMode);
        
        if (rewrittenText) {
          const modeTitle = REWRITE_MODES.find(m => m.key === rewriteMode)?.title || rewriteMode;
          const formattedContent = `REWRITE (${modeTitle}):\n\n${rewrittenText}`;
          
          const topZIndex = zManagerRef.current._getTopZIndex() + 10;
          const newStickyId = await addNote(topZIndex, 'regular');
          
          if (newStickyId) {
            await updateNote(newStickyId, {
              content: formattedContent,
              zIndex: topZIndex,
              type: 'regular',
              main_x: dropPosition.x,
              main_y: dropPosition.y,
              main_width: 450,
              main_height: 350
            });
            
            handleNoteFocus(newStickyId);
            setDisplayModes(prev => ({...prev, [newStickyId]: 'both'}));
          }
        } else {
          alert('Failed to rewrite text');
        }
      } catch (err) {
        console.error('Error rewriting text:', err);
        alert('Failed to rewrite the text with AI');
      } finally {
        setProcessingIndicators(prev => 
          prev.filter(indicator => indicator.id !== indicatorId)
        );
        setIsProcessingDrop(false);
      }
    } else if (action === 'new') {
      const topZIndex = zManagerRef.current._getTopZIndex() + 10;
      const newStickyId = await addNote(topZIndex, 'regular');
      
      if (newStickyId) {
        await updateNote(newStickyId, {
          content: droppedContent,
          zIndex: topZIndex,
          type: 'regular',
          main_x: dropPosition.x,
          main_y: dropPosition.y,
          main_width: 450,
          main_height: 300
        });
        
        handleNoteFocus(newStickyId);
        setDisplayModes(prev => ({...prev, [newStickyId]: 'both'}));
      }
    }
  };


  // Handle image paste to create new image notes
useEffect(() => {
  const handlePaste = async (e) => {
    // Only handle if not focused on an input/textarea/contenteditable
    if (e.target.tagName === 'INPUT' || 
        e.target.tagName === 'TEXTAREA' || 
        e.target.isContentEditable) {
      return;
    }
    
    const items = e.clipboardData?.items;
    if (!items) return;
    
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.startsWith('image/')) {
        e.preventDefault();
        const imageFile = items[i].getAsFile();
        
        try {
          console.log('📸 Pasting image to create new note...');
          const result = await uploadImageNote(
            selectedWorkspacePublicId,
            imageFile,
            100, // Default X position
            100  // Default Y position
          );
          
          console.log('✅ Image note created:', result);
          await fetchNotes(); // Refresh to show new note
          
        } catch (error) {
          console.error('❌ Failed to paste image:', error);
          alert('Failed to paste image');
        }
        
        return;
      }
    }
  };
  
  document.addEventListener('paste', handlePaste);
  return () => document.removeEventListener('paste', handlePaste);
}, [selectedWorkspacePublicId, fetchNotes]);

    useEffect(() => {
    if (showDropMenu) {
      const handleClickOutside = (e) => {
        if (!e.target.closest('.drop-menu')) {
          setShowDropMenu(false);
        }
      };
      
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showDropMenu]);

    useEffect(() => {
      if (effectiveNotePublicId && notes && notes.length > 0) {
          //console.log(`📌 Note changed! Loading notes for note ${selectedDocumentPublicId}`);

          // Get current notes in ZIndexManager
          const currentNotes = Array.from(zManagerRef.current._zIndices.keys());
          const newNoteIds = notes.map(note => note.id);

          // Remove notes that belong to the previous note
          const stickiesToRemove = currentNotes.filter(id => !newNoteIds.includes(id));

          if (stickiesToRemove.length > 0) {
              //console.log("🧹 Removing old notes from ZIndexManager:", stickiesToRemove);
              stickiesToRemove.forEach(id => {
                  zManagerRef.current._zIndices.delete(id);
              });

              // ✅ Completely replace the ZIndexManager instance!
              //console.log("🛑 Fully Resetting ZIndexManager...");
              zManagerRef.current = new ZIndexManagerMain(); // 🔥 Creates a fresh instance
          }

          // 📌 Adjust note positions if needed
          const stickiesWithoutMainCoords = notes.filter(
              note => note.main_x === null || note.main_y === null
          );

          if (stickiesWithoutMainCoords.length > 0) {
              const noteUpdates = stickiesWithoutMainCoords.map((note, index) => {
                  const columnWidth = 250;
                  const rowHeight = 200;
                  const columnsPerRow = Math.floor(window.innerWidth / columnWidth);
                  const row = Math.floor(index / columnsPerRow);
                  const col = index % columnsPerRow;

                  return {
                      id: note.id,
                      main_x: col * columnWidth + 100,
                      main_y: row * rowHeight + 150,
                      main_width: note.width || 150,
                      main_height: note.height || 150
                  };
              });

              noteUpdates.forEach(update => {
                  updateNote(update.id, update);
              });
          }

          // ✅ Delay re-initialization to allow React state updates
        // console.log("🔍 ABOUT TO SET TIMEOUT - called from:", new Error().stack.split('\n')[2]);
          setTimeout(() => {
          //  console.log("🚀 Re-initializing notes for new note");
            //  console.log("🚀 Re-initializing notes for new note - STACK:", new Error().stack.split('\n')[1]);
              zManagerRef.current.initializeStickies(notes);
          }, 10);
          setShowNotePreview(true);
      }
  }, [effectiveNotePublicId, updateNote]); 

    // Add this to StickysViewMain.js
  const handleFreezeLayout = useCallback(() => {
    const noteUpdates = notes.map(note => ({
      id: note.id,
      x: note.x,
      y: note.y,
      width: note.width,
      height: note.height,
      main_x: note.main_x,
      main_y: note.main_y,
      main_width: note.main_width,
      main_height: note.main_height,
      display_mode: displayModes[note.id] || 'both',
      z_index: note.zIndex,
      is_minimized: note.is_minimized
    }));
    
    // Call the same saveNoteLayout function that the list panel uses
    saveNoteLayout(noteUpdates);
const selectedWorkspace = getSelectedWorkspace(); 
if (currentPreviewPositionRef.current && selectedWorkspace?.public_id) {
  updateWorkspacePreviewPosition(
    selectedWorkspace.public_id,
    currentPreviewPositionRef.current
  );
}
}, [notes, displayModes, saveNoteLayout, getSelectedWorkspace, updateWorkspacePreviewPosition]);


    const handleNoteFocus = useCallback((noteId) => {
      const note = notes.find(s => s.id === noteId);
      if (!note) return;

      const newZIndex = zManagerRef.current.bringToFront(noteId);
      if (newZIndex !== null) {
        updateNote(noteId, { zIndex: newZIndex });
      }
    }, [notes, updateNote]);

    const handleAddSticky = useCallback(async () => {
    // Analyze existing notes for domain context
    const existingDomains = notes
      .filter(s => s.tag1) // Only count notes that have domains set
      .map(s => s.tag1);
    
    let defaultDomain = 'General';
    let defaultTag = 'note';
    
    if (existingDomains.length > 0) {
      // Find most common domain
      const domainCounts = {};
      existingDomains.forEach(domain => {
        domainCounts[domain] = (domainCounts[domain] || 0) + 1;
      });
      
      // Get domain with highest count
      defaultDomain = Object.keys(domainCounts).reduce((a, b) => 
        domainCounts[a] > domainCounts[b] ? a : b
      );
      
      // Get first tag for that domain
      const availableTags = tagDomains[defaultDomain] || [];
      defaultTag = availableTags[0] || 'note';
    }

    const topZIndex = zManagerRef.current._getTopZIndex() + 10;
    const newStickyId = await addNote(topZIndex, stickyType);
    
    if (newStickyId) {
      const newZIndex = zManagerRef.current.addSticky(newStickyId);
      
      const stickiesWithMainCoords = notes.filter(
        note => note.main_x !== null && note.main_y !== null &&
                  (!displayModes[note.id] || displayModes[note.id] !== 'list')
      );
      const existingCount = stickiesWithMainCoords.length;
      
      await updateNote(newStickyId, {
        zIndex: newZIndex,
        type: stickyType,
        title: null,
        main_x: 75 + (existingCount * 80),
        main_y: 100 + (existingCount * 70),      
        main_width: 450,
        main_height: 300,
        content: '',
        tag1: defaultDomain, // Add this
        tag2: defaultTag     // Add this
      });

      handleNoteFocus(newStickyId);
    }
  }, [stickyType, addNote, updateNote, handleNoteFocus, notes, tagDomains, displayModes]);

    useEffect(() => {
      notes.forEach((note) => {
        if (!zManagerRef.current._zIndices.has(note.id)) {
          const newZ = zManagerRef.current.addSticky(note.id);
          updateNote(note.id, { zIndex: newZ });
        }
      });
    }, [notes, updateNote]);
    

    const handleSelectChange = useCallback((noteId, isSelected) => {
    setSelectedStickies(prev => ({
      ...prev,
      [noteId]: isSelected
    }));
    
    // Save to localStorage
    const newState = { ...selectedNotes, [noteId]: isSelected };
    localStorage.setItem(`selected-notes-${selectedDocumentPublicId}`, JSON.stringify(newState));
  }, [selectedNotes, selectedDocumentPublicId]);

  const handleToggleDisplayMode = useCallback((noteId, newMode) => {
    // console.log(`handleToggleDisplayMode called: note ${noteId} to mode ${newMode}`);
    // console.log(`selectedDocumentPublicId:`, selectedDocumentPublicId);
      

      //console.log(`Updating note ${noteId} display_mode to ${newMode}`);
      updateNote(noteId, { 
        display_mode: newMode,
      });

      setDisplayModes(prev => {
        const newModes = {
          ...prev,
          [noteId]: newMode
        };
      //  console.log('Updated displayModes:', newModes);
        return newModes;
      });
    }, [updateNote]);

    const handleExpandFromList = useCallback((noteId) => {
      handleNoteFocus(noteId);
    }, [handleNoteFocus]);

    const handleSaveLayout = useCallback((noteUpdates) => {
      saveNoteLayout(noteUpdates);
    }, [saveNoteLayout]);


  const getNoteComponent = (note) => {
    return StickyNote;
  };

    // ✅ FIX: Use useCallback to create a function that accesses current state
  const getSelectedStickyIdsArray = useCallback(() => {
    // Build the current selected stickies from latest state
    const currentSelectedStickies = {};
    notes?.forEach(note => {
      if (selectedNotes[note.id]) {
        currentSelectedStickies[note.id] = true;
      }
    });
    
    return Object.entries(currentSelectedStickies)
      .filter(([_, isSelected]) => isSelected)
      .map(([id]) => id);
  }, [notes, selectedNotes]);  // ✅ Depends on current notes and selectedNotes

  // ✅ FIX: Create getSelectedCount callback that uses the current function
  const getSelectedCount = useCallback(() => {
    return getSelectedStickyIdsArray().length;
  }, [getSelectedStickyIdsArray]);


  const handleOpenAIModal = useCallback(() => {
    setIsAICompositionModalOpen(true);
  }, []);

  const handleSendToAI = (selectedNotes) => {
    //console.log('Sending to AI from main panel:', selectedNotes);
    setIsAICompositionModalOpen(false);
  };

  // ✅ FIX: Add getSelectedCount to dependencies so it updates when selection changes
  useEffect(() => {
    if (onFunctionsReady) {
      onFunctionsReady({
        handleAddSticky,
        cycleArrangements,
        handleOpenAIModal,
        handleFreezeLayout,
        getSelectedCount  // ✅ Now this function will always return current count
      });
    }
  }, [handleAddSticky, cycleArrangements, handleOpenAIModal, handleFreezeLayout, getSelectedCount, onFunctionsReady]);

  return (
    <div className={`${styles.container} content-container`}>

    

  <div 
    className={styles.stickyContainer}
    onDragOver={handleDragOver} 
    onDrop={handleDrop}
  >

    {/* Show message if expanded arrangement but no document */}
      {arrangementMode === 'expandedNote' && !selectedNote?.public_id && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'var(--panelMuted)',
          fontSize: '18px',
          fontWeight: '500'
        }}>
          📄 Workspace has no Document
          <div style={{ fontSize: '14px', marginTop: '10px', opacity: 0.7 }}>
            Create a document to use expanded view
          </div>
        </div>
      )}
    {/* Add the note preview note */}
    {showNotePreview && (
        <NotePreviewSticky
            selectedNote={selectedNote}
            key={selectedNote?.public_id}
            onClose={() => setShowNotePreview(false)}
            onRequestDelete={onRequestDelete}
            isInMainPanel={true}
            forceMinimized={selectedNote?.preview_height === 45}
             onExposePosition={handlePreviewPositionUpdate} 
          />
    )}
          
    {notes?.map((note) => {
      //Alternatively, you could show a loading state until displayModes is properly initialized:
  // javascript// Don't render notes until displayModes is initialized
  // if (notes?.length > 0 && Object.keys(displayModes).length === 0) {
  //   return <div>Loading notes...</div>;
  // }
      if (displayModes[note.id] === 'list' || 
            (Object.keys(displayModes).length === 0 && note.display_mode === 'list')) {
          return null;
        }

      const NoteComponent = getNoteComponent(note);
      
      return (
        <NoteComponent
          key={note.id}
          sticky={note}
          tagDomains={tagDomains}
          updateSticky={updateNote}
          removeSticky={(id) => {
            zManagerRef.current.removeSticky(id);
            removeNote(id);
          }}
          maxZIndex={zManagerRef.current._getTopZIndex()}
          onFocus={() => handleNoteFocus(note.id)}
          onToggleDisplayMode={handleToggleDisplayMode}
          isSelected={Boolean(selectedNotes[note.id])}
          onSelectChange={handleSelectChange}
          isInMainPanel={true}
          addSticky={addNote}
          registerWithZManager={registerNoteWithZManager}
          saveStickyLayout={handleSaveLayout}
          notePublicId={selectedDocumentPublicId}
          workspacePublicId={selectedWorkspacePublicId}  
        />
      );
    })}

    {/* Add processing indicators */}
    {renderProcessingIndicators()}
    
    {/* Add drop menu */}
    {showDropMenu && (
      <div 
        className="drop-menu" 
        style={{ 
          position: 'absolute', 
          left: dropPosition.x, 
          top: dropPosition.y,
          zIndex: 9999,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '4px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          padding: '8px',
          minWidth: '180px'
        }}
      >
        <div className="drop-menu-header" style={{ padding: '4px 12px', fontWeight: 'bold' }}>
          Choose action:
        </div>
        
        <button 
          className="drop-menu-button"
          onClick={() => handleDropMenuAction('new')}
          style={{ 
            display: 'block',
            width: '100%',
            textAlign: 'left',
            padding: '8px 12px',
            margin: '4px 0',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            backgroundColor: 'transparent',
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#f5f5f5'}
          onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
          disabled={isProcessingDrop}
        >
          New Sticky
        </button>
        
        <div style={{ height: '1px', backgroundColor: '#eee', margin: '8px 0' }}></div>
        
        <div style={{ padding: '4px 12px', fontWeight: 'bold', fontSize: '0.9em', color: '#555' }}>
          AI Extract:
        </div>
        
        {QUICK_EXTRACTION_TYPES.map(type => (
          <button 
            key={type.key}
            className="drop-menu-button"
            onClick={() => handleDropMenuAction(`ai_${type.key}`)}
            style={{ 
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '8px 12px',
              margin: '4px 0',
              border: 'none',
              borderRadius: '4px',
              cursor: isProcessingDrop ? 'not-allowed' : 'pointer',
              backgroundColor: 'transparent',
              opacity: isProcessingDrop ? 0.7 : 1
            }}
            onMouseOver={(e) => !isProcessingDrop && (e.target.style.backgroundColor = '#f5f5f5')}
            onMouseOut={(e) => !isProcessingDrop && (e.target.style.backgroundColor = 'transparent')}
            disabled={isProcessingDrop}
          >
            {type.title}
          </button>
        ))}
        
        {isProcessingDrop && (
          <div style={{ padding: '8px 12px', color: '#4f46e5', fontSize: '0.9em' }}>
            Processing with AI...
          </div>

          
        )}

        {/* ADD THIS SECTION: */}
  <div style={{ height: '1px', backgroundColor: '#eee', margin: '8px 0' }}></div>

  <div style={{ padding: '4px 12px', fontWeight: 'bold', fontSize: '0.9em', color: '#555' }}>
    AI Rewrite:
  </div>

  {REWRITE_MODES.map(mode => (
    <button 
      key={mode.key}
      className="drop-menu-button"
      onClick={() => handleDropMenuAction(`rewrite_${mode.key}`)}
      style={{ 
        display: 'block',
        width: '100%',
        textAlign: 'left',
        padding: '8px 12px',
        margin: '4px 0',
        border: 'none',
        borderRadius: '4px',
        cursor: isProcessingDrop ? 'not-allowed' : 'pointer',
        backgroundColor: 'transparent',
        opacity: isProcessingDrop ? 0.7 : 1
      }}
      onMouseOver={(e) => !isProcessingDrop && (e.target.style.backgroundColor = '#f5f5f5')}
      onMouseOut={(e) => !isProcessingDrop && (e.target.style.backgroundColor = 'transparent')}
      disabled={isProcessingDrop}
    >
      {mode.title}
    </button>
  ))}
      </div>
    )}
  </div>
    
        <StickiesListPanel
        isInMainPanel={true}  
        tagDomains={tagDomains} 
        isRightPanelVisible={isRightPanelVisible}
        isLeftPanelVisible={isLeftPanelVisible} // Add this prop
        stickies={notes || []}
        onExpandSticky={handleExpandFromList}
        displayModes={displayModes}
        onToggleDisplayMode={handleToggleDisplayMode}
        selectedStickies={selectedNotes} // Changed from pinnedStickies
        onSelectChange={handleSelectChange} // New prop
        onSaveLayout={handleSaveLayout}
        onRemoveSticky={(id) => {
        console.log(`🗑️ Removing note ${id} from list panel`);
        zManagerRef.current.removeSticky(id);  // Clean up z-index manager
        removeNote(id);                      // Remove from state
      }}
        onReorderSticky={reorderNotes}  // ADD THIS LINE
        updateSticky={updateNote}
      />
        {/* <DraggableFreezeButton onFreeze={handleFreezeLayout} />
        <DraggableAIButton 

    key={`ai-button-${selectedDocumentPublicId}`} 
    onOpenAIModal={handleOpenAIModal} 
    pinnedCount={getSelectedStickyIdsArray().length}
  /> */}

  {isAICompositionModalOpen && (
    <>
      {/* ✅ DEBUG MORE */}
      {console.log('🔍 Selected IDs:', getSelectedStickyIdsArray())}
      {console.log('🔍 All notes:', notes.map(n => ({ id: n.id, type: typeof n.id })))}
      {console.log('🔍 Filtered notes:', notes.filter(n => getSelectedStickyIdsArray().includes(String(n.id))))}
      
      <AICompositionModal
        isOpen={isAICompositionModalOpen}
        onClose={() => setIsAICompositionModalOpen(false)}
        notes={notes || []}
        selectedNoteIds={getSelectedStickyIdsArray()}
        selectedNotes={notes.filter(n => getSelectedStickyIdsArray().includes(String(n.id)))}
        onSendToAI={handleSendToAI}
        addNote={addNote}
        updateNote={updateNote}
        maxZIndex={zManagerRef.current._getTopZIndex()}
        onFocus={handleNoteFocus}
      />
    </>
  )}
      </div>
    );
    };
    
    export default React.memo(StickysViewMain);